import { fannieMaeRoundLtv } from './fannieMaeRoundLtv'

export function calculateRefinanceLoanToValue(
  remainingBalance: number,
  propertyValue: number,
  cashOut = 0
): number {
  if (!propertyValue || !remainingBalance) {
    return 0
  }
  if (isNaN(propertyValue) || isNaN(remainingBalance) || isNaN(cashOut)) {
    return 0
  }

  const ltvDecimal = (remainingBalance + cashOut) / propertyValue
  return fannieMaeRoundLtv(ltvDecimal)
}

export function calculatePurchaseLoanToValue(
  purchasePrice: number,
  downPayment: number
): number {
  if (!purchasePrice || !downPayment) return 100
  if (isNaN(purchasePrice) || isNaN(downPayment)) return 100

  const ltvDecimal = 1 - downPayment / purchasePrice
  return fannieMaeRoundLtv(ltvDecimal)
}
